import { updatableListActions } from '../GeneralListFunctions/actionFactory'
export default updatableListActions('EVENT')
